import { Dashboard } from 'ui/components/company/patterns/Dashboard/Dashboard';

/**
 * 売り手企業ダッシュボード
 */
export const CompanyDashboard: React.FC = () => {
    return <Dashboard />;
};
